import { useEffect, useState } from "react";
import { Car } from "lucide-react";
import { api, qs } from "@/lib/api";
import { Card } from "@/components/Kpi";
import { NewsCard } from "@/components/NewsCard";

const TEMI = [
  ["", "Tutto"],
  ["vendite", "Vendite e immatricolazioni"],
  ["finanziamenti", "Finanziamenti auto"],
  ["usato", "Mercato dell'usato"],
];

/** Sezione "Mondo auto": notizie su vendite, immatricolazioni, finanziamenti e usato. */
export function NewsAuto({ periodo, competitorNomi }) {
  const [tema, setTema] = useState("");
  const [rows, setRows] = useState([]);
  const [totale, setTotale] = useState(0);
  const [limit, setLimit] = useState(6);

  useEffect(() => {
    api.get(`/news/feed?${qs({ sezione: "auto", tema, periodo, ordina: "data", limit })}`)
      .then((r) => { setRows(r.data.rows); setTotale(r.data.totale); })
      .catch(() => setRows([]));
  }, [tema, periodo, limit]);

  return (
    <div className="mb-10" data-testid="news-auto">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <h3 className="uppercase text-xs tracking-[0.18em] font-semibold text-slate-500 flex items-center gap-2">
          <Car size={14} className="text-[#C8102E]" /> Mondo auto
          <span className="text-slate-400 normal-case tracking-normal">
            (vendite, immatricolazioni, finanziamenti e usato · {totale} notizie)
          </span>
        </h3>
        <div className="flex flex-wrap gap-1.5" data-testid="news-auto-temi">
          {TEMI.map(([k, l]) => (
            <button key={k} type="button" onClick={() => { setTema(k); setLimit(6); }}
              data-testid={`news-auto-tema-${k || "tutto"}`}
              className={`px-3 py-1 rounded-full text-xs font-semibold border transition-colors duration-200
                ${tema === k ? "bg-[#C8102E] border-[#C8102E] text-white"
                  : "bg-white border-slate-200 text-slate-600 hover:border-[#C8102E] hover:text-[#C8102E]"}`}>
              {l}
            </button>
          ))}
        </div>
      </div>
      {rows.length === 0 ? (
        <Card className="p-6 text-sm text-slate-500" data-testid="news-auto-vuoto">
          Nessuna notizia sull'auto nel periodo selezionato{tema === "usato" ? " per il mercato dell'usato" : ""}.
        </Card>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="news-auto-griglia">
            {rows.map((a) => <NewsCard key={a.slug} a={a} competitorNomi={competitorNomi} compact />)}
          </div>
          {totale > rows.length && (
            <div className="mt-3 text-right">
              <button type="button" onClick={() => setLimit((l) => l + 6)} data-testid="news-auto-altre"
                className="text-sm text-sky-700 hover:text-sky-900 transition-colors duration-200">
                Mostra altre ({totale - rows.length})
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
